<template>
  <div>
    <h3>Submit a ticket</h3>
    <form action="#" @submit.prevent="formHandler">
      <span class="text-primary">ticket information</span>
      <div class="va-row mt-2 align--center">
        <div class="flex md1 xs12 required">
          <label for="department">Department</label>
        </div>
        <div
          class="flex md4 xs12"
          :class="error.departmentId ? 'has-error' : ''"
        >
          <vuestic-simple-select
            v-if="departments"
            :options="departments"
            :optionKey="'name'"
            v-model="department"
            :clearable="false"
            :pholder="'Select department'"
            required
          />
          <span class="small text-danger">{{ error.departmentId }}</span>
        </div>
      </div>
      <div class="va-row align--center">
        <div class="flex md1 xs12 required">
          <label for="phone">Phone</label>
        </div>
        <div class="flex md4 xs12">
          <div class="form-group" :class="error.phone ? 'has-error' : ''">
            <div class="input-group">
              <input
                type="text"
                id="phone"
                v-model="model.phone"
                placeholder="Phone"
                required
              />
              <i class="bar"></i>
              <span class="small text-danger">{{ error.phone }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="va-row align--center">
        <div class="flex md1 xs12 required">
          <label for="subject">Subject</label>
        </div>
        <div class="flex md5 xs12">
          <div class="form-group" :class="error.subject ? 'has-error' : ''">
            <div class="input-group">
              <input
                type="text"
                id="subject"
                placeholder="Subject"
                v-model="model.subject"
                required
              />
              <i class="bar"></i>
              <span class="small text-danger">{{ error.subject }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="va-row">
        <div class="flex md1 xs12 required">
          <label for="description">Description</label>
        </div>
        <div
          class="flex md5 xs12"
          :class="error.description ? 'has-error' : ''"
        >
          <wysiwyg v-model="model.description" />
          <span class="small text-danger">{{ error.description }}</span>
        </div>
      </div>
      <div class="va-row align--center">
        <div class="flex md1 xs12">
          <label for="product_name">Product Name</label>
        </div>
        <div class="flex md4 xs12">
          <div class="form-group" :class="error.product ? 'has-error' : ''">
            <div class="input-group">
              <input
                type="text"
                id="product_name"
                placeholder="Product Name"
                v-model="model.product"
              />
              <i class="bar"></i>
              <span class="small text-danger">{{ error.product }}</span>
            </div>
          </div>
        </div>
      </div>
      <br />
      <hr />
      <span class="text-primary">Additional information</span>
      <div class="va-row align--center">
        <div class="flex md1 xs12">
          <label for="priority">Priority</label>
        </div>
        <div class="flex md4 xs12" :class="error.priority ? 'has-error' : ''">
          <vuestic-simple-select
            :options="priorities"
            v-model="model.priority"
            :clearable="true"
            :pholder="'Select priority'"
          />
          <span class="small text-danger">{{ error.priority }}</span>
        </div>
      </div>
      <div class="va-row align--center">
        <div class="flex md1 xs12">
          <label for="classification">Classification</label>
        </div>
        <div
          class="flex md4 xs12"
          :class="error.classification ? 'has-error' : ''"
        >
          <vuestic-simple-select
            :options="classifications"
            v-model="model.classification"
            :clearable="true"
            :pholder="'Select classification'"
          />
          <span class="small text-danger">{{ error.classification }}</span>
        </div>
      </div>
      <div class="va-row">
        <div
          class="flex md6 xs12"
          :class="error.classification ? 'has-error' : ''"
        >
          <vuestic-file-upload v-model="model.file" />
          <span class="small text-danger">{{ error.file }}</span>
        </div>
      </div>
      <div class="va-row">
        <half-circle-spinner
          slot="loading"
          :animation-duration="1500"
          :size="50"
          color="#94c120"
          v-show="formLoading"
          class="mx-auto"
        />
        <div class="flex md2 xs6" v-if="!formLoading">
          <button type="submit" class="btn btn-primary btn-sm btn-block">
            Submit
          </button>
        </div>
        <div class="flex md2 xs6" v-if="!formLoading">
          <button type="reset" class="btn btn-danger btn-sm btn-block">
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  name: 'AskInnoTab',
  components: {
    HalfCircleSpinner
  },
  data() {
    return {
      formLoading: false,
      attachments: [],
      department: {},
      priorities: ['High', 'Medium', 'Low'],
      classifications: ['Problem', 'Question', 'Request​', 'Others'],
      model: {},
      error: {}
    }
  },
  computed: {
    ...mapGetters(['departments'])
  },
  methods: {
    ...mapActions(['getDepartments', 'openTicket']),
    async formHandler() {
      this.formLoading = true
      this.model.departmentId = this.department.id
      const response = await this.openTicket(this.model)

      if (response.success) {
        this.$toasted.show(response.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
        this.model = {}
        this.department = {}
      } else {
        this.error = response.errors
      }
      this.formLoading = false
    }
  },
  async created() {
    if (!this.departments.length) {
      await this.getDepartments()
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  &:after {
    content: '';
    display: block;
    width: 100%;
    border-bottom: 2px solid $lighter-gray;
    margin-top: 5px;
  }
}
.form-group {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
label {
  margin-bottom: 0;
}
.va-row:not(:only-child) {
  margin: 20px -0.5rem !important;
}
</style>
<style>
.vuestic-simple-select .form-group {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
@media (max-width: 767px) {
  .editr--toolbar {
    overflow-x: scroll;
    overflow-y: hidden;
  }
}
</style>
